module.exports = __webpack_public_path__ + "img/12-sdg-border@2x.8af951df.png";